import { useCallback, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import { getUserLanguage, languages, onChangeLanguage } from "../utils/i18n";

export const useNavigationLanguage = () => {
  const { i18n } = useTranslation();
  const [selectedLanguage, setSelectedLanguage] = useState<string>(() => getUserLanguage());

  useEffect(() => {
    if (typeof i18n.on !== "function" || typeof i18n.off !== "function") {
      return undefined;
    }

    const handleLanguageChanged = (language: string) => {
      setSelectedLanguage(language);
    };

    i18n.on("languageChanged", handleLanguageChanged);

    return () => {
      i18n.off("languageChanged", handleLanguageChanged);
    };
  }, [i18n]);

  const handleLanguageChange = useCallback((value: string) => {
    const language = languages.find(language => language.value === value);

    if (!language) {
      return;
    }

    setSelectedLanguage(value);
    void onChangeLanguage(language);
  }, []);

  return {
    handleLanguageChange,
    selectedLanguage,
  };
};
